import React from 'react'

function LinkEdingIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
      <g data-name="Group 57241" transform="translate(-679 -746)">
        <rect
          width="20"
          height="20"
          fill="#263238"
          data-name="Rectangle 9311"
          rx="2"
          transform="translate(679 746)"
        ></rect>
        <g fill="#fff" data-name="Group 57235" transform="translate(683 750)">
          <path
            d="M.2 4.44h2.655l.014 7.779H.211zM1.54.224a1.555 1.555 0 011.54 1.568 1.555 1.555 0 01-1.54 1.566A1.553 1.553 0 010 1.792 1.554 1.554 0 011.54.224"
            data-name="Path 13494"
            transform="translate(0 -.224)"
          ></path>
          <path
            d="M89.135 79.311h2.338v1.082h.033a2.557 2.557 0 012.307-1.278c2.469 0 2.924 1.639 2.924 3.769v4.34H94.3v-3.848c0-.918-.016-2.1-1.267-2.1-1.269 0-1.462 1-1.462 2.032v3.914h-2.436z"
            data-name="Path 13495"
            transform="translate(-84.738 -75.225)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default LinkEdingIcon
